import { render, staticRenderFns } from "./steps-wizard.vue?vue&type=template&id=31abb29d&"
import script from "./steps-wizard.vue?vue&type=script&lang=js&"
export * from "./steps-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports